<template>
	<div v-on="$listeners" class="text-image-card-wrapper">
		<div class="image">
			<el-image style="width: 100%; height: 100%" :src="formattedItem.image" fit="cover" lazy></el-image>
			<div v-if="formattedItem?.isTop" class="is-top">{{ $t('enterprise.top-post') }}</div>
		</div>
		<div class="content mt-12 text-overflow2">{{ formattedItem.title }}</div>
		<div v-if="formattedItem.time" class="date mt-8">{{ formatDateFn(formattedItem.time) }}</div>
	</div>
</template>

<script setup>
import { computed } from 'vue';
import { dateFormatYearMonthDate } from '@/utils/format';

/**
 * 组件属性定义
 * @typedef {Object} Props
 * @property {Object} item - 原始数据对象
 * @property {Function} [formatter] - 可选的格式化函数，用于将原始数据转换为组件所需格式
 */
const props = defineProps({
	item: {
		type: Object,
		default: () => ({})
	},
	/**
	 * 格式化函数，用于字段重命名或数据转换
	 * @param {Object} rawItem - 原始数据对象
	 * @returns {Object} 返回的对象会与原始数据合并
	 * @example
	 * :formatter="data => ({ time: data.stime })"
	 */
	formatter: {
		type: Function,
		default: null
	}
});

const formattedItem = computed(() => {
	if (props.formatter && typeof props.formatter === 'function') {
		const formattedData = props.formatter(props.item);
		// 将格式化后的数据与原始数据合并，formatter 返回的字段优先级更高
		return { ...props.item, ...formattedData };
	}
	return props.item;
});

const formatDateFn = date => dateFormatYearMonthDate(date);
</script>

<style lang="less" scoped>
.text-image-card-wrapper {
	cursor: pointer;

	.image {
		height: 189px;
		cursor: pointer;
		position: relative;

		/deep/.el-image__inner {
			transition: all 0.18s ease-in-out;
		}
		&:hover {
			/deep/.el-image__inner {
				transform: scale(1.08);
			}
		}
		.is-top {
			position: absolute;
			top: 0;
			right: 0;
			padding: 0 10px;
			height: 20px;
			line-height: 20px;
			font-size: 12px;
			font-weight: 400;
			color: #ffffff;
			border-radius: 0 0 2px 2px;
			background: #f23d3d;
		}
	}
	.content {
		font-size: 16px;
		font-weight: 500;
		line-height: 24px;
		color: #1d2129;
	}
	.date {
		font-size: 12px;
		font-weight: 400;
		line-height: 18px;
		color: #4e5969;
	}
}
</style>
